import Instanoti from 'instanoti-js';
import shortid from 'shortid';

import Registry from "../registry";

import { LOGIN_SUCCESS } from '../constants/general';
import {COUNTER_NOTIFICATION} from '../constants/notifications';
import {
    SERVICE_MESSAGE,
    TIP_NOTIFICATION,
    GIFT_NOTIFICATION,
    WALL_POST_NOTIFICATION,
    MEMBERSHIP_GIFT_NOTIFICATION,
    PERSONAL_ROOM_ACTIVATED_NOTIFICATION,
    SHOWROOM_ACTIVATED_NOTIFICATION
} from '../constants/serviceMessage';

import { MY_VIDEO_WINDOW_RECORD_ERROR } from '../constants/myVideoWindow';

import { receiveNotification, privateTokenNotification } from '../actions/notifications';

const socketMiddleware = function socketMiddleware(store) {
    let socket;
    return function (next) {
        return function (action) {
            switch(action.type) {
                case LOGIN_SUCCESS: {

                    if(action.user.isAnonymous()) {
                        break;
                    }

                    let server_uri = window.location.origin
                                    .replace("http://", "ws://")
                                    .replace("https://", "wss://");
                    socket = new Instanoti({
                        server_uri: `${server_uri}/instanoti/websocket`,
                        on_open: data => {
                            console.log("Instanoti connected")
                        },
                        on_close: data => {
                            console.log("Instanoti disconnected")
                        },
                        on_error: err => {
                            console.log("Instanoti error", err)
                        },
                        on_counter: data => {
                            store.dispatch({
                                type: COUNTER_NOTIFICATION,
                                data: data.data
                            });
                        },
                        on_tip: data => {
                            store.dispatch(receiveNotification(data));
                        },
                        on_tip_private_sent: data => {
                            store.dispatch(privateTokenNotification(data));
                        },
                        on_tip_private_received: data => {
                            store.dispatch(receiveNotification(data));
                            store.dispatch(privateTokenNotification(data));
                        },
                        on_tip_public: data => {
                            const { data: { id, meta: { sender, recipient, amount, roomid, server_id }}} = data;
                            const currentRoom = store.getState().currentRoom;
                            if (currentRoom.server_id != server_id) return;
                            const message = {
                                data: {
                                    id,
                                    amount,
                                    sender: sender.nick,
                                    receiver: recipient.nick,
                                },
                                roomid: roomid,
                                type: TIP_NOTIFICATION,
                            };

                            store.dispatch({ type: SERVICE_MESSAGE, message });
                        },
                        on_new_follower: data => {
                            store.dispatch(receiveNotification(data));
                        },
                        on_gift: data => {
                            store.dispatch(receiveNotification(data));
                        },
                        on_message: data => {
                            store.dispatch(receiveNotification(data));
                        },
                        on_membership_gift: data => {
                            store.dispatch(receiveNotification(data));
                        },
                        on_followed_user_is_online: data => {
                            const newData = {
                                ...data,
                                data: {
                                    ...data.data,
                                    is_read: 0,
                                    id: `${data.type}:${shortid.generate()}`
                                }
                            };
                            store.dispatch(receiveNotification(newData));
                        },
                        on_membership_gift_public: data => {
                            const { data: { id, meta: { sender, recipient, duration }}} = data;

                            const message = {
                                data: {
                                    id,
                                    duration,
                                    sender: sender.nick,
                                    receiver: recipient.nick,
                                },
                                type: MEMBERSHIP_GIFT_NOTIFICATION,
                            };

                            store.dispatch({ type: SERVICE_MESSAGE, message });
                        },
                        on_guestbook_message: data => {
                            store.dispatch(receiveNotification(data));
                        },
                        on_user_membership_expired: data => {
                            store.dispatch(receiveNotification(data));
                        },
                        on_user_membership_almost_expired: data => {
                            store.dispatch(receiveNotification(data));
                        },
                        on_gift_public: data => {
                            const { data: { id, meta: { sender, recipient, gift }}} = data;

                            const message = {
                               data: {
                                   id,
                                   anon: 0,
                                   image_url: gift.img,
                                   receiver: recipient.nick,
                                   sender: sender.id === 0 ? '' : sender.nick,
                                   senderProfileURL: sender.id === 0 ? '' : `/profil/${sender.nick}`,
                                   receiverProfileURL: `/profil/${recipient.nick}`
                               },
                                type: GIFT_NOTIFICATION
                            };

                            store.dispatch({ type: SERVICE_MESSAGE, message });
                        },
                        on_wall: data => {
                            const { data: { meta: { material, user, url }}} = data;

                            const message = {
                                data: {
                                    url,
                                    id: `ws${material.id}`,
                                    type: material.type,
                                    sender: user.nick,
                                    material_id: material.id,
                                    media_url: material.media,
                                    thumbnail_url:  material.thumbnail,
                                    senderProfileURL: `/profil/${user.nick}`
                                },
                                type: WALL_POST_NOTIFICATION
                            };

                            store.dispatch({ type: SERVICE_MESSAGE, message });
                        },
                        on_new_personal_room: data => {
                            const { data: { entity_id, meta: { room, creator }}} = data;
                            const message = {
                                data: {
                                    roomid: `ws${entity_id}`,
                                    name: room.name,
                                    url: room.url,
                                    creator: {
                                        id: creator.id,
                                        nick: creator.nick,
                                        avatar_url: creator.avatar_url,
                                        profile_url: `/profil/${creator.nick}`,
                                    }
                                },
                                type: PERSONAL_ROOM_ACTIVATED_NOTIFICATION
                            };
                            store.dispatch({ type: SERVICE_MESSAGE, message });
                        },
                        on_new_showroom: data => {
                            const { data: { entity_id, meta: { room, creator }}} = data;
                            const message = {
                                data: {
                                    roomid: `ws${entity_id}`,
                                    name: room.name,
                                    url: room.url,
                                    creator: {
                                        id: creator.id,
                                        nick: creator.nick,
                                        avatar_url: creator.avatar_url,
                                        profile_url: `/profil/${creator.nick}`,
                                    }
                                },
                                type: SHOWROOM_ACTIVATED_NOTIFICATION
                            };
                            store.dispatch({ type: SERVICE_MESSAGE, message });
                        },
                        on_stream_record_error: data => {
                            const lang = Registry.get('locale');
                            store.dispatch(receiveNotification(data));
                            store.dispatch({ type: MY_VIDEO_WINDOW_RECORD_ERROR, message: lang.streamRecordError });
                        },
                        reconnect: true
                    });
                    break;
                }
            }
        return next(action);
      };
    };
  };

export default socketMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/instanoti.js